import { render, staticRenderFns } from "./MenuOperation.vue?vue&type=template&id=0a857f48&"
import script from "./MenuOperation.vue?vue&type=script&lang=js&"
export * from "./MenuOperation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports